<div class="view-wrapper profile-view" @viewLoader>
  <div class="view-content bottom-space" #scrollRoot>
    @if (showCompletenessHint()) {
      <ct-lib-info-banner class="completeness-hint">
        <p>
          {{
            'jobboard.platform.profile.completeness-hint'
              | transloco: { percent: completenessPercent() }
          }}
        </p>
      </ct-lib-info-banner>
    }

    <form [formGroup]="profileForm">
      <section id="contact" class="view-section">
        <h4>{{ 'jobboard.platform.profile.sections.contact.title' | transloco }}</h4>
        <app-platform-profile-contact
          [form]="profileForm"
          [photoNonce]="photoNonce()"
          [submitAttempt]="submitAttempt()"
        ></app-platform-profile-contact>
      </section>
      <section id="preferences" class="view-section">
        <h4>{{ 'jobboard.platform.profile.sections.preferences.title' | transloco }}</h4>
        <app-platform-profile-preferences
          [form]="profileForm"
          [submitAttempt]="submitAttempt()"
        ></app-platform-profile-preferences>
      </section>
      <section id="social" class="view-section">
        <h4>{{ 'jobboard.platform.profile.sections.social.title' | transloco }}</h4>
        <app-platform-profile-social
          [form]="profileForm"
          [submitAttempt]="submitAttempt()"
        ></app-platform-profile-social>
      </section>
      <section id="documents" class="view-section">
        <h4>{{ 'jobboard.platform.profile.sections.documents.title' | transloco }}</h4>
        <app-platform-profile-documents
          [form]="profileForm"
          (documentsSynced)="onDocumentsSynced()"
        ></app-platform-profile-documents>
      </section>
      <section id="skills" class="view-section">
        <h4>{{ 'jobboard.platform.profile.sections.skills.title' | transloco }}</h4>
        <app-platform-profile-skills
          [form]="profileForm"
          (duplicateSkill)="onDuplicateSkill()"
        ></app-platform-profile-skills>
      </section>
      <section id="languages" class="view-section">
        <h4>{{ 'jobboard.platform.profile.sections.languages.title' | transloco }}</h4>
        <app-platform-profile-languages
          [form]="profileForm"
          (duplicateLanguage)="onDuplicateLanguage()"
        ></app-platform-profile-languages>
      </section>
    </form>

    <ct-lib-form-saver
      [form]="profileForm"
      [busy]="saving()"
      (onSave)="onSave()"
      (onDiscard)="onDiscard()"
    ></ct-lib-form-saver>
  </div>
</div>
